<template>
  <Layout>
    <PageTitle />

    <div class="page-padding page-padding-all">
      <ApplicationsTable />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import ApplicationsTable from './applicationsTable/ApplicationsTable.vue'

export default {
  page: {
    title: 'Аккаунты',
  },
  components: {
    Layout,
    ApplicationsTable,
    PageTitle: () => import('./PageTitle.vue'),
  },
}
</script>

<style lang="scss" scoped>
.app-header {
  @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);

  @include media_tablet {
    @include createFlex(flexbox, nowrap, row, space-between, center, center);
  }
}
</style>
